'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoSubmitPropertyFormInvalid = exports.canAutoSubmitPropertyForm = exports.canSubmitBooking = exports.canSubmitMeetingTime = exports.canSubmitPropertyForm = exports.canSubmitStagedPropertyForm = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _FormFieldValidationSelector = require('MeetingsLib/selectors/FormFieldValidationSelector');

var _LegalConsentFormSelectors = require('./LegalConsentFormSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmbedded = (0, _get2.default)('embedded');

var checkAllFormValidation = function checkAllFormValidation(formStateValidation) {
  if (!formStateValidation) {
    return false;
  }

  var customFieldsInvalid = formStateValidation.get('customFormFields').filter(function (fieldValidation) {
    return Boolean(fieldValidation);
  }).size > 0;

  var isEmailInvalid = Boolean(formStateValidation.get('email'));
  var isFirstNameInvalid = Boolean(formStateValidation.get('firstName'));
  var isLastNameInvalid = Boolean(formStateValidation.get('lastName'));

  return !(customFieldsInvalid || isEmailInvalid || isFirstNameInvalid || isLastNameInvalid);
};

var canSubmitStagedPropertyForm = exports.canSubmitStagedPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getStagedFormFieldValidation], checkAllFormValidation);
var canSubmitPropertyForm = exports.canSubmitPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getFormFieldValidation], checkAllFormValidation);

var canSubmitMeetingTime = exports.canSubmitMeetingTime = (0, _reselect.createSelector)([_BookInfoSelectors.getEvent], function (event) {
  return Boolean(event.dateTime);
});

var canSubmitBooking = exports.canSubmitBooking = (0, _reselect.createSelector)([canSubmitMeetingTime, canSubmitPropertyForm, _LegalConsentFormSelectors.getAllRequiredConsentCollected], function (meetingTimeValid, propertyFormValid, legalConsentValid) {
  return meetingTimeValid && propertyFormValid && legalConsentValid;
});

var canAutoSubmitPropertyForm = exports.canAutoSubmitPropertyForm = (0, _reselect.createSelector)([canSubmitPropertyForm, getEmbedded], function (canSubmit, embedded) {
  return canSubmit && embedded;
});

var autoSubmitPropertyFormInvalid = exports.autoSubmitPropertyFormInvalid = (0, _reselect.createSelector)([canSubmitPropertyForm], function (canSubmit) {
  return !canSubmit;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/AutoSubmitSelector.js
// module id = 119
// module chunks = 0